
import React, { useState } from "react";
import { FormField } from "@/components/dashboard/shops/types";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { PencilIcon, CheckIcon } from "lucide-react";

interface FieldNameProps {
  field: FormField;
  isEditing: boolean;
  updateFieldName: (id: string, name: string) => void;
}

export const FieldName: React.FC<FieldNameProps> = ({
  field,
  isEditing,
  updateFieldName
}) => {
  const [isEditingName, setIsEditingName] = useState(false);
  const [newName, setNewName] = useState(field.label);
  
  // Vérifier si c'est un champ téléphone (peut avoir des restrictions)
  const isPhoneField = field.type === 'phone' || 
                     field.name === 'customerPhone' || 
                     field.name === 'Téléphone' ||
                     field.name.toLowerCase().includes('phone') || 
                     field.name.toLowerCase().includes('téléphone');

  const handleEditName = () => {
    if (!isEditing) return;
    setIsEditingName(true);
  };

  const handleSaveName = () => {
    if (newName.trim() === '') return;
    updateFieldName(field.id, newName);
    setIsEditingName(false);
  };

  if (isEditing && isEditingName) {
    return (
      <div className="flex items-center gap-1">
        <Input
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          className="h-8 py-1 text-sm"
          autoFocus
          onKeyDown={(e) => e.key === 'Enter' && handleSaveName()}
        />
        <Button
          variant="ghost"
          size="sm"
          onClick={handleSaveName}
          className="h-8 w-8 p-0"
        >
          <CheckIcon className="h-4 w-4" />
        </Button>
      </div>
    );
  }

  return (
    <div 
      className="flex items-center cursor-default"
      onClick={handleEditName}
    >
      <span className={`text-sm font-medium ${!field.enabled && !isPhoneField ? 'text-gray-400' : ''}`}>
        {field.label}
      </span>
      {isEditing && (
        <Button
          variant="ghost"
          size="sm"
          className="h-6 w-6 p-0 ml-1"
          onClick={handleEditName}
        >
          <PencilIcon className="h-3 w-3" />
        </Button>
      )}
    </div>
  );
};
